module.exports = __webpack_public_path__ + "static/media/fc_square.520b37f3.png";